import { AppConfigs } from "../types";
import { featuresDev } from "./featuresDev";
import { featuresProd } from "./featuresProd";
import { featuresStage } from "./featuresStage";

export const config: AppConfigs = {
  configs: {
    dev: {
      features: featuresDev,
    },
    stage: {
      features: featuresStage,
    },
    prod: {
      features: featuresProd,
    },
  },
};
